export default {
  __html: `<g fill="none" fill-rule="evenodd" transform="rotate(180 40,40)">
                <g fill="#201A5B" fill-rule="nonzero">
                    <path d="M50.33 74.854a3.012 3.012 0 0 1-2.136-.873 2.93 2.93 0 0 1 0-4.175l17.767-17.67c.583-.583.874-1.36.874-2.136 0-.777-.291-1.553-.874-2.136L48.194 30.097a2.93 2.93 0 0 1 0-4.175 2.93 2.93 0 0 1 4.175 0L70.136 43.69c1.65 1.65 2.621 3.98 2.621 6.311 0 2.427-.97 4.66-2.621 6.31L52.369 73.98c-.486.583-1.262.874-2.039.874z"/>
                    <path d="M50.524 53.01H28.583c-1.651 0-3.01-1.36-3.01-3.01 0-1.65 1.359-3.01 3.01-3.01h21.941c1.65 0 3.01 1.36 3.01 3.01 0 1.65-1.36 3.01-3.01 3.01z"/>
                </g>
                <path d="M.913.388h99.029v99.029H.913z"/>
            </g>`
}



// WEBPACK FOOTER //
// ./src/app/elements/Icon/left-arrow-large.js